interface NativeBridgeUI {
  showToolbar(): Promise<void>;
  hideToolbar(): Promise<void>;
  updateToolbarTitle(title: string): Promise<void>;
  back(): Promise<void>;
  exit(): Promise<void>;
}

interface NativeBridgeAPI {
  onStatus(
    statusCode: number,
    url: string,
  ): Promise<{ action: string; shouldRetry?: boolean; rejected?: boolean }>;
}

interface NativeBridgeScanner {
  onScanResult(callback: (scanData: string) => void): () => void;
}

export interface NativeBridge {
  __moduleId: string;
  ui: NativeBridgeUI;
  api: NativeBridgeAPI;
  scanner?: NativeBridgeScanner;
}

declare global {
  interface Window {
    NativeBridge?: NativeBridge;
  }
}

const POLL_INTERVAL_MS = 100;
const MAX_WAIT_MS = 3000;

let _bridge: NativeBridge | null = null;
let _bridgeReady = false;
let _waitPromise: Promise<void> | null = null;
let _readyCallbacks: Array<() => void> = [];

export const waitForBridge = (): Promise<void> => {
  if (_bridgeReady) return Promise.resolve();
  if (_waitPromise) return _waitPromise;

  _waitPromise = new Promise<void>((resolve) => {
    const timer = setInterval(() => {
      if (window.NativeBridge) {
        clearInterval(timer);
        clearTimeout(timeout);
        _bridge = window.NativeBridge;
        _bridgeReady = true;
        _waitPromise = null;
        _readyCallbacks.forEach((cb) => cb());
        _readyCallbacks = [];
        resolve();
      }
    }, POLL_INTERVAL_MS);

    const timeout = setTimeout(() => {
      clearInterval(timer);
      _waitPromise = null;
      resolve();
    }, MAX_WAIT_MS);
  });

  return _waitPromise;
};

export const getBridge = (): NativeBridge | null => _bridge;

export const isBridgeReady = (): boolean => _bridgeReady;

export const onBridgeReady = (cb: () => void): (() => void) => {
  if (_bridgeReady) {
    cb();
    return () => {};
  }
  _readyCallbacks.push(cb);
  return () => {
    _readyCallbacks = _readyCallbacks.filter((c) => c !== cb);
  };
};
